module.exports = __webpack_public_path__ + "assets/img/criancas2.8ebb965e.jpg";